"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4970],{

/***/ 50297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ MessengerColored; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32600);


const MessengerColored = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "-149.1 -248.49675 1292.2 1490.9805" },
    child: [
      {
        tag: "g",
        attr: { transform: "translate(-15 -11.5)" },
        child: [
          {
            tag: "linearGradient",
            attr: {
              y2: "1005.5",
              x2: "512",
              y1: "11.5",
              x1: "512",
              gradientUnits: "userSpaceOnUse",
              id: "a"
            },
            child: [
              { tag: "stop", attr: { offset: "0", stopColor: "#00b2ff" } },
              { tag: "stop", attr: { offset: "1", stopColor: "#006aff" } }
            ]
          },
          {
            tag: "path",
            attr: {
              d: "M512 11.5c-280 0-497 205.1-497 482.1 0 144.9 59.4 270.1 156.1 356.6 8.1 7.3 13 17.4 13.4 28.3l2.7 88.4c.9 28.2 30 46.5 55.8 35.2l98.6-43.5c8.4-3.7 17.7-4.4 26.5-2 45.3 12.5 93.6 19.1 143.9 19.1 280 0 497-205.1 497-482.1S792 11.5 512 11.5z",
              fill: "url(#a)",
              fillRule: "evenodd",
              clipRule: "evenodd"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M213.6 634.6l146-231.6c23.2-36.8 73-46 107.8-19.9l116.1 87.1c10.7 8 25.3 7.9 35.9-.1l156.8-119c20.9-15.9 48.3 9.2 34.2 31.4L664.5 614c-23.2 36.8-73 46-107.8 19.9l-116.1-87.1c-10.7-8-25.3-7.9-35.9.1L247.8 666c-20.9 15.9-48.3-9.2-34.2-31.4z",
              fillRule: "evenodd",
              clipRule: "evenodd",
              fill: "#fff"
            }
          }
        ]
      }
    ]
  })(props);
};




/***/ }),

/***/ 96494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ CustomLink; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35874);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86029);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Anchor = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.a */ .z.a`
  color: unset;
  text-decoration: unset;
`;
const CustomLink = (_a) => {
  var _b = _a, {
    targetPath,
    children,
    targetType = "_self",
    passHref = false
  } = _b, props = __objRest(_b, [
    "targetPath",
    "children",
    "targetType",
    "passHref"
  ]);
  if (!targetPath)
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, children);
  const a11yProps = {};
  if (typeof children !== "string") {
    a11yProps["aria-label"] = "Image";
  }
  if (targetPath.startsWith("http") || targetPath.startsWith("/"))
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Anchor, __spreadValues(__spreadValues({
      target: targetType,
      href: targetPath
    }, a11yProps), props), children);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
    href: passHref ? targetPath : `/search?${targetPath}`,
    prefetch: false,
    legacyBehavior: true
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Anchor, __spreadValues(__spreadValues({
    target: targetType,
    href: passHref ? targetPath : `/search?${targetPath}`
  }, a11yProps), props), children));
};




/***/ }),

/***/ 32777:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* binding */ Footer; }
});

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-48286aefe3/1/packages/ecommerce/dist/i18n.es.js
var i18n_es = __webpack_require__(33627);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/libs/styled.es.js
var styled_es = __webpack_require__(86029);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/Container/Container.es.js
var Container_es = __webpack_require__(81142);
// EXTERNAL MODULE: ../../.yarn/__virtual__/reflexbox-virtual-125c14c7ff/0/cache/reflexbox-npm-4.0.6-201af1058c-b532551c8b.zip/node_modules/reflexbox/dist/index.js
var dist = __webpack_require__(81026);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/Button/Button.es.js
var Button_es = __webpack_require__(5510);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-48286aefe3/1/packages/ecommerce/dist/Layout/Footer/components/FooterBlock/FooterBlock.es.js



var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const ColumnTitle = styled_es/* styled.div */.z.div`
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 10px;
`;
const StyledButton = (0,styled_es/* styled */.z)(Button_es/* Button */.z)((props) => `
  font-size: 12px;
  color: #333;
  padding-left: 0px;
  text-align: left;
  text-decoration: none;
  padding-bottom: 0px;
  max-width: ${!props.block ? "72px" : "initial"};
  justify-content: flex-start;
`);
const ContactInnerLine = styled_es/* styled.div */.z.div`
  font-size: 12px;
  width: 100%;
  a {
    text-decoration: none;
  }
  span {
    line-height: 1.5rem;
  }
  padding-top: 0.365rem;
  padding-right: 0.75rem;
`;
const StyledImg = styled_es/* styled.img */.z.img((props) => `
  ${props.isLogo ? "max-width: 180px;" : ""}
  width: 100%;
`);
const FooterBlock = ({
  title,
  links = [],
  emails = [],
  phones = [],
  flexDir = "row",
  image,
  isLogoImage,
  btnBlock = true
}) => {
  return /* @__PURE__ */ react.createElement(react.Fragment, null, title && /* @__PURE__ */ react.createElement(ColumnTitle, {
    key: title
  }, title), emails.map((email, index) => {
    return /* @__PURE__ */ react.createElement(ContactInnerLine, {
      key: `email-${index}`,
      dangerouslySetInnerHTML: {
        __html: `${email.children} <a href='mailto:${email.address}'>${email.address}</a>`
      }
    });
  }), phones.map((phone, index) => {
    return /* @__PURE__ */ react.createElement(ContactInnerLine, {
      key: `phone-${index}`,
      dangerouslySetInnerHTML: {
        __html: `${phone.children} <a href='tel:${phone.number.replace(/\./g, "")}'}>${phone.number}</a>`
      }
    });
  }), links.map((link, index) => {
    return /* @__PURE__ */ react.createElement(StyledButton, __spreadValues({
      tag: "a",
      block: btnBlock,
      link: true,
      key: `link-${index}`,
      flexDirection: flexDir
    }, link));
  }), image && /* @__PURE__ */ react.createElement(StyledImg, {
    isLogo: !!isLogoImage,
    src: image,
    alt: ""
  }));
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-48286aefe3/1/packages/ecommerce/dist/Layout/Footer/Footer.es.js






const FooterWrapper = styled_es/* styled.div */.z.div(({ theme }) => `
  @media print {
    display: none;
  }
  border-top: solid 3px ${theme == null ? void 0 : theme.brand.primary};
  position: relative;
`);
const Wrapper = styled_es/* styled.nav */.z.nav(({ theme }) => `
  background-color: ${theme == null ? void 0 : theme.colors.white};
  padding: 1rem 0;
`);
const StyledContainer = (0,styled_es/* styled */.z)(Container_es/* Container */.W)`
  display: flex;
  margin-bottom: 10px;
`;
const ColumnInnerLine = styled_es/* styled.div */.z.div`
  font-size: 12px;
  width: 100%;
  padding-right: 8px;
  a {
    color: #333;
    text-decoration: none;
    display: flex;
    align-items: center;
  }
  span {
    line-height: 1.5rem;
  }
`;
const StyledWrapper = (0,styled_es/* styled */.z)(Wrapper)(({ customBottomColor, theme }) => `
  background-color: ${customBottomColor && (theme == null ? void 0 : theme.colors[customBottomColor]) || "#e9edf2"};
  margin-top: -10px;
  padding-top: 30px;
  padding-bottom: 25px;
`);
const CompanyName = styled_es/* styled.div */.z.div`
  font-size: 14px;
  text-transform: uppercase;
  font-weight: bold;
  margin-bottom: 15px;
`;
const BranchName = styled_es/* styled.span */.z.span`
  font-size: 12px;
  font-weight: bold;
`;
const Footer_es_StyledImg = styled_es/* styled.img */.z.img`
  width: 100%;
  max-width: 160px;
`;
const StyledLink = styled_es/* styled.a */.z.a`
  display: block;
  &:not(:first-child) {
    margin-top: 0.5rem;
  }
`;
const StyledDMCA = styled_es/* styled.div */.z.div`
  margin-top: 0.5rem;
  img {
    width: 100%;
    max-width: 100px;
  }
`;
const Description = styled_es/* styled.p */.z.p`
  font-size: 0.75rem;
  text-align: center;
  margin: 0;
`;
const getResponsiveWidth = (col) => {
  switch (col) {
    case 2:
      return [1 / 2, 1 / 2, 1 / 2, 1 / 2];
    case 3:
      return [1 / 2, 1 / 2, 1 / 2, 1 / 3];
    case 4:
      return [1 / 2, 1 / 2, 1 / 2, 1 / 4];
    default:
      return [1 / 2, 1 / 3, 1 / 3, 1 / 5];
  }
};
const Footer = ({
  footer,
  customBottomColor,
  baseUrl
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o;
  return /* @__PURE__ */ react.createElement(FooterWrapper, null, (footer.bankList || footer.supportAndPolicy || footer.paymentMethods) && /* @__PURE__ */ react.createElement(Wrapper, null, footer.supportAndPolicy && /* @__PURE__ */ react.createElement(StyledContainer, null, /* @__PURE__ */ react.createElement(dist/* Flex */.kC, {
    flexWrap: "wrap",
    justifyContent: "space-between",
    width: "100%"
  }, footer.supportAndPolicy.map((column, index) => {
    return /* @__PURE__ */ react.createElement(dist/* Box */.xu, {
      width: !!footer.supportAndPolicy ? getResponsiveWidth(footer.supportAndPolicy.length) : void 0,
      key: index
    }, /* @__PURE__ */ react.createElement(FooterBlock, {
      title: column.title,
      links: column.links,
      emails: column.emails,
      phones: column.phones,
      image: column.image,
      isLogoImage: true
    }));
  }))), /* @__PURE__ */ react.createElement(StyledContainer, null, /* @__PURE__ */ react.createElement(dist/* Flex */.kC, {
    flexWrap: "wrap"
  }, footer.paymentMethods && /* @__PURE__ */ react.createElement(dist/* Box */.xu, {
    width: [1, 1, "40%"]
  }, /* @__PURE__ */ react.createElement(FooterBlock, {
    title: footer.paymentMethods.title,
    links: footer.paymentMethods.links,
    flexDir: "column",
    btnBlock: false
  })), footer.bankList && /* @__PURE__ */ react.createElement(dist/* Box */.xu, {
    width: [1, 1, "60%"]
  }, /* @__PURE__ */ react.createElement(FooterBlock, {
    title: (0,i18n_es.t)("Danh s\xE1ch c\xE1c ng\xE2n h\xE0ng thanh to\xE1n online"),
    image: footer.bankList.imgSrc
  }))))), footer.bottom && /* @__PURE__ */ react.createElement(StyledWrapper, {
    customBottomColor
  }, /* @__PURE__ */ react.createElement(StyledContainer, null, /* @__PURE__ */ react.createElement(dist/* Flex */.kC, {
    flexWrap: "wrap",
    width: "100%"
  }, /* @__PURE__ */ react.createElement(dist/* Box */.xu, {
    width: [1, "50%", "35%", "40%"]
  }, ((_a = footer.bottom) == null ? void 0 : _a.company) && /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(CompanyName, null, (_b = footer.bottom) == null ? void 0 : _b.company.name), /* @__PURE__ */ react.createElement(ColumnInnerLine, {
    dangerouslySetInnerHTML: {
      __html: (_c = footer.bottom) == null ? void 0 : _c.company.detail
    }
  }))), /* @__PURE__ */ react.createElement(dist/* Box */.xu, {
    width: [1, "50%", "35%", "40%"]
  }, footer.bottom.address && footer.bottom.address.map((addressDetail) => {
    return /* @__PURE__ */ react.createElement("div", {
      key: addressDetail.branchName
    }, /* @__PURE__ */ react.createElement(BranchName, null, addressDetail.branchName), ":", /* @__PURE__ */ react.createElement(ColumnInnerLine, null, addressDetail.branchAddress));
  }), footer.bottom.phone && footer.bottom.email && /* @__PURE__ */ react.createElement(ColumnInnerLine, null, `${(0,i18n_es.t)("S\u1ED1 \u0111i\u1EC7n tho\u1EA1i")}: ${footer.bottom.phone} - Email: ${footer.bottom.email} `)), /* @__PURE__ */ react.createElement(dist/* Box */.xu, {
    width: [1, "100%", "30%", "20%"]
  }, !!((_e = (_d = footer == null ? void 0 : footer.bottom) == null ? void 0 : _d.registeredLogo) == null ? void 0 : _e.logo) && /* @__PURE__ */ react.createElement(StyledLink, {
    href: (_f = footer.bottom.registeredLogo) == null ? void 0 : _f.link,
    rel: "noreferrer noopener",
    target: "_blank"
  }, /* @__PURE__ */ react.createElement(Footer_es_StyledImg, {
    src: footer.bottom.registeredLogo.logo,
    alt: "registered logo"
  })), !!((_h = (_g = footer == null ? void 0 : footer.bottom) == null ? void 0 : _g.verifiedLogo) == null ? void 0 : _h.logo) && /* @__PURE__ */ react.createElement(StyledLink, {
    href: (_i = footer.bottom.verifiedLogo) == null ? void 0 : _i.link,
    rel: "noreferrer noopener",
    target: "_blank"
  }, /* @__PURE__ */ react.createElement(Footer_es_StyledImg, {
    src: footer.bottom.verifiedLogo.logo,
    alt: "verified logo"
  })), ((_j = footer == null ? void 0 : footer.bottom) == null ? void 0 : _j.dmcaBadgeLink) && ((_k = footer == null ? void 0 : footer.bottom) == null ? void 0 : _k.dmcaId) && /* @__PURE__ */ react.createElement(StyledDMCA, null, /* @__PURE__ */ react.createElement("a", {
    href: `//www.dmca.com/Protection/Status.aspx?ID=${(_l = footer == null ? void 0 : footer.bottom) == null ? void 0 : _l.dmcaId}&refurl=${baseUrl}`,
    title: "DMCA.com Protection Status",
    className: "dmca-badge"
  }, /* @__PURE__ */ react.createElement("img", {
    src: `${(_m = footer == null ? void 0 : footer.bottom) == null ? void 0 : _m.dmcaBadgeLink}?ID=${(_n = footer == null ? void 0 : footer.bottom) == null ? void 0 : _n.dmcaId}`,
    alt: "DMCA.com Protection Status"
  })))), /* @__PURE__ */ react.createElement(dist/* Box */.xu, {
    width: [1]
  }, ((_o = footer == null ? void 0 : footer.bottom) == null ? void 0 : _o.description) && /* @__PURE__ */ react.createElement(Description, {
    dangerouslySetInnerHTML: {
      __html: footer.bottom.description
    }
  }))))));
};




/***/ }),

/***/ 33627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ NAMESPACE; },
/* harmony export */   "t": function() { return /* binding */ t; }
/* harmony export */ });
/* harmony import */ var i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96556);


var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const NAMESPACE = "ecommerce";
const t = (keys, options) => {
  const text = i18next__WEBPACK_IMPORTED_MODULE_0__["default"].t(keys, __spreadProps(__spreadValues({}, options), {
    ns: NAMESPACE,
    interpolation: { escapeValue: false }
  }));
  return text || keys;
};




/***/ }),

/***/ 81142:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79690);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86029);



const Container = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(styled_system__WEBPACK_IMPORTED_MODULE_0__.space, ({ fluid }) => {
  const styles = {
    width: "100%",
    marginLeft: "auto",
    marginRight: "auto",
    paddingLeft: "1rem",
    paddingRight: "1rem"
  };
  if (!fluid) {
    styles.maxWidth = "1264px";
  }
  return styles;
});




/***/ }),

/***/ 30752:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ LazyImage; },
/* harmony export */   "x": function() { return /* binding */ WebpImage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86029);



const Wrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div((props) => ({
  maxWidth: "100%",
  position: "relative",
  overflow: "hidden",
  flex: "1 0 auto",
  display: "flex",
  cursor: props.onClick ? "pointer" : "unset",
  zIndex: 0,
  margin: "auto",
  borderRadius: props.borderRadius + "px",
  paddingBottom: props.height ? "" : `${100 / props.aspectRatio}%`,
  border: props.border ? "1px solid #e0e0e0" : "",
  height: props.height ? `${props.height}px !important` : "",
  width: props.width ? `${props.width}px` : "100%",
  backgroundImage: props.thumbnail ? `url("${props.thumbnail}")` : null,
  backgroundSize: props.thumbnail ? "cover" : null,
  contentVisibility: props.height && props.width ? "auto" : null
}));
const WebpImage = ({
  src,
  onClick,
  className,
  height,
  width,
  imageWidth,
  alt = "",
  decoding = "async"
}) => {
  const placeHolder = "data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNjAiIGhlaWdodD0iMjYwIiB2aWV3Qm94PSIwIDAgMjYwIDI2MCI+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxwYXRoIGZpbGw9IiNGNkY2RjYiIGQ9Ik0wIDBoMjYwdjI2MEgweiIvPgogICAgICAgIDxwYXRoIGQ9Ik0xMDQgMTA0aDU0djU0aC01NHoiLz4KICAgICAgICA8cGF0aCBmaWxsPSIjQjRCNEI0IiBkPSJNMTUxLjI1IDEwNi4yNWE0LjUgNC41IDAgMCAxIDQuNSA0LjV2NDAuNWE0LjUgNC41IDAgMCAxLTQuNSA0LjVoLTQwLjVhNC41IDQuNSAwIDAgMS00LjUtNC41di00MC41YTQuNSA0LjUgMCAwIDEgNC41LTQuNWg0MC41em0tMTMuNSAxOGwtOSAxMy41TDEyMiAxMzFsLTYuNzUgMTEuMjVoMzEuNWwtOS0xOHptLTEyLjM3NS02Ljc1YTMuMzc1IDMuMzc1IDAgMSAwIDAgNi43NSAzLjM3NSAzLjM3NSAwIDAgMCAwLTYuNzV6Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=";
  let imageUrl = src ? src : placeHolder;
  let altImageUrl = null;
  if (imageUrl && imageUrl.includes("googleusercontent.com")) {
    if (imageWidth || width) {
      imageUrl = `${imageUrl}=w${imageWidth || width}`;
    }
    const checkExt = /=[a-z0-9-]+$/;
    altImageUrl = imageUrl;
    imageUrl = `${imageUrl}${checkExt.test(imageUrl) ? "-rw" : "=rw"}`;
  }
  const imgError = (event) => {
    if (event.target.src !== placeHolder) {
      event.target.src = placeHolder;
    }
    return;
  };
  const imgEle = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
    width,
    height,
    onClick,
    className,
    alt,
    onError: imgError,
    src: imageUrl,
    loading: "lazy",
    decoding
  });
  return altImageUrl ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("picture", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("source", {
    srcSet: imageUrl,
    type: "image/webp"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("source", {
    srcSet: altImageUrl,
    type: "image/png"
  }), imgEle) : imgEle;
};
const WrapperImage = (0,_libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(WebpImage)((props) => `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: ${props.contain ? "contain" : props.cover ? "cover" : ""};
  transition: transform 0.5s;
  &:hover {
    transform: ${props.hover === "zoom" ? "scale(1.05)" : ""};
  }
  `);
const LazyImage = ({
  src,
  onClick,
  className,
  contain = false,
  cover = false,
  aspectRatio = 1,
  height,
  width,
  alt = "",
  border = false,
  hover = "",
  borderRadius = 0,
  thumbnail,
  decoding = "async",
  imageWidth
}) => {
  const imgEle = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(WrapperImage, {
    hover,
    className: "lazyload",
    contain,
    imageWidth,
    cover,
    alt,
    "data-src": src,
    src,
    decoding
  });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    height,
    width,
    border,
    aspectRatio,
    borderRadius,
    onClick,
    className,
    thumbnail
  }, imgEle);
};




/***/ }),

/***/ 56265:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ ScrollTopArrow; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86029);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28247);
/* harmony import */ var _atoms_SvgIcon_SvgIcon_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(49781);






var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const ScrollToTopBtn = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div((props) => `
  border-radius: 50%;
  background-color: ${props.backgroundColor};
  display: flex;
  justify-content: center;
  align-items: center;
  width: 3rem;
  height: 3rem;
  box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.08);
`);
const ScrollToTopWrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(({ showScroll, position }) => `
  display: ${showScroll ? "block" : "none"};
  z-index: 1030;
  position: fixed;
  ${position.bottom ? `bottom: ${position.bottom}rem;` : ""}
  ${position.top ? `top: ${position.top}rem;` : ""}
  ${position.left ? `left: ${position.left}rem;` : ""}
  ${position.right ? `right: ${position.right}rem;` : ""}
  cursor: pointer;
  animation: fadeIn 0.3s;
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 0.5;
    }
  }
`);
const ScrollTopArrow = ({
  className,
  color = "#ffffff",
  backgroundColor = " #333333",
  position = { bottom: 10, right: 3 },
  scrollTopRouters
}) => {
  const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
  const [showScroll, setShowScroll] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const scrollTopTop = () => {
    if (typeof window !== "undefined")
      window.scroll({ top: 0, left: 0, behavior: "smooth" });
  };
  const checkScrollTop = () => {
    if (typeof window !== "undefined") {
      if (!showScroll && window.pageYOffset > 700) {
        setShowScroll(true);
      } else if (showScroll && window.pageYOffset <= 700) {
        setShowScroll(false);
      }
    }
  };
  if (typeof window !== "undefined")
    window.addEventListener("scroll", checkScrollTop);
  let hasRouter = false;
  (scrollTopRouters == null ? void 0 : scrollTopRouters.length) > 0 && scrollTopRouters.forEach((route) => {
    if (router.pathname.startsWith(route)) {
      hasRouter = true;
      return;
    }
  });
  if ((scrollTopRouters == null ? void 0 : scrollTopRouters.length) > 0 && !hasRouter)
    return null;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ScrollToTopWrapper, __spreadValues({
    showScroll,
    position
  }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_3__/* .getTrackingData */ .O5)({
    isTrackContent: true,
    regionName: "btnScrollTop",
    contentName: "btnScrollTop"
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ScrollToTopBtn, {
    className,
    onClick: () => scrollTopTop(),
    backgroundColor
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_atoms_SvgIcon_SvgIcon_es_js__WEBPACK_IMPORTED_MODULE_4__/* .SvgIcon */ .l, {
    name: "up",
    size: 24,
    color
  })));
};




/***/ }),

/***/ 92926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ ForceLogin; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91987);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(34655);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _teko_auth_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(44254);
/* harmony import */ var _components_Loading__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(35904);
/* harmony import */ var _terra_js_web_bridge__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85172);
/* harmony import */ var _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78246);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(98992);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(71323);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(48441);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(31260);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85470);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _teko_user__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(20483);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(84443);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(43015);
/* harmony import */ var _teko_log__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20577);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(5709);















// this sucks
// ideally, we should never have to import both mobile and desktop component
// should use router.push instead. Let routing handle that.
const UpdateProfileDesktop = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(()=>Promise.all(/* import() */[__webpack_require__.e(9690), __webpack_require__.e(1668), __webpack_require__.e(358), __webpack_require__.e(3667), __webpack_require__.e(9781), __webpack_require__.e(1763), __webpack_require__.e(6873), __webpack_require__.e(4614)]).then(__webpack_require__.bind(__webpack_require__, 64614)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(64614)
            ]
    }
});
const UpdateProfileMobile = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(()=>Promise.all(/* import() */[__webpack_require__.e(9690), __webpack_require__.e(1668), __webpack_require__.e(358), __webpack_require__.e(3667), __webpack_require__.e(9781), __webpack_require__.e(1763), __webpack_require__.e(6873), __webpack_require__.e(2093)]).then(__webpack_require__.bind(__webpack_require__, 72093)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(72093)
            ]
    }
});
// this component should be phased out
const UpdateInfoForm = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(()=>Promise.all(/* import() */[__webpack_require__.e(9690), __webpack_require__.e(9781), __webpack_require__.e(5531)]).then(__webpack_require__.bind(__webpack_require__, 93309)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(93309)
            ]
    }
});
const BYPASS_LOGIN_PATHS = /^.*(\/content\/\[id\])|(\/p\/\[slug\])|(\/landing\/\[id\])$/;
const useConfirmDealerAssignment = (refCode)=>{
    const { identityRequired  } = (0,contexts__WEBPACK_IMPORTED_MODULE_7__/* .useTenantConfig */ .Wx)();
    const { user  } = (0,_teko_auth_react__WEBPACK_IMPORTED_MODULE_8__/* .useAuth */ .a)();
    const { showModal  } = (0,_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_9__/* .useModal */ .d)();
    const { userService  } = (0,contexts__WEBPACK_IMPORTED_MODULE_10__/* .useServices */ .Su)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const onCancelPopup = ()=>{
        var ref;
        sessionStorage.removeItem("ref_code");
        if (!(user === null || user === void 0 ? void 0 : (ref = user.dealer) === null || ref === void 0 ? void 0 : ref.id) && identityRequired === "dealer-required") {
            var // if require dealer, signout
            ref1, ref2;
            window === null || window === void 0 ? void 0 : (ref1 = window.TekoID) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.user) === null || ref2 === void 0 ? void 0 : ref2.logout();
        } else {
            setLoading(false);
            router.replace("/", undefined, {
                shallow: true
            });
        }
    };
    const popup = (param)=>{
        let { title , message , onOk , okText , onCancel , cancelText  } = param;
        showModal({
            title: title || (0,i18n__WEBPACK_IMPORTED_MODULE_11__.t)("Th\xf4ng b\xe1o"),
            okText: okText || (0,i18n__WEBPACK_IMPORTED_MODULE_11__.t)("Đ\xf3ng"),
            cancelText: cancelText || "",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_12__/* .Body */ .uT, {
                children: message
            }),
            onOk: onOk || onCancelPopup,
            onCancel: onCancel || onCancelPopup,
            showCloseIcon: false,
            fullWidthFooter: true
        });
    };
    const { 0: loading , 1: setLoading  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(!!refCode);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (refCode && user) {
            const handleConfirmError = (err)=>{
                var ref;
                sessionStorage.removeItem("ref_code");
                _teko_log__WEBPACK_IMPORTED_MODULE_6__/* .logger.error */ .k.error(err);
                // error can be anything
                // @ts-ignore
                popup({
                    message: (err === null || err === void 0 ? void 0 : err.message) || (err === null || err === void 0 ? void 0 : (ref = err.response) === null || ref === void 0 ? void 0 : ref.message) || ""
                });
            };
            const onAssignDealerSuccess = ()=>{
                sessionStorage.removeItem("ref_code");
                popup({
                    message: (0,i18n__WEBPACK_IMPORTED_MODULE_11__.t)("Đăng k\xfd t\xe0i khoản th\xe0nh c\xf4ng"),
                    title: (0,i18n__WEBPACK_IMPORTED_MODULE_11__.t)("Th\xf4ng b\xe1o"),
                    okText: (0,i18n__WEBPACK_IMPORTED_MODULE_11__.t)("Đ\xf3ng"),
                    onOk: ()=>{
                        // router.replace('/');
                        // setLoading(false);
                        // force reload page so that user.dealer data is re-fetched
                        window.location.href = "/";
                    }
                });
            };
            (async ()=>{
                try {
                    const refCodeInfo = await userService.getRefCodeInfo(refCode);
                    const { dealer  } = refCodeInfo.data || {};
                    if (!dealer) {
                        // if there is no dealer,
                        throw new Error("Invalid refCode " + refCode);
                    }
                    if (user.dealer) {
                        if (user.dealer.id === dealer.id) {
                            // dealer is already assigned,
                            // there is nothing to do
                            onCancelPopup();
                            return;
                        }
                        // else confirm if user are ok with the change
                        const msg = (0,_teko_utils__WEBPACK_IMPORTED_MODULE_13__/* .customizedMessage */ .$e)((0,i18n__WEBPACK_IMPORTED_MODULE_11__.t)("_template.desktop._module.components.IdentityRequired.1"), [
                            {
                                name: "oldDealer",
                                value: user.dealer.name || user.dealer.telephone
                            },
                            {
                                name: "newDealer",
                                value: dealer.name || dealer.telephone
                            }, 
                        ]);
                        popup({
                            message: msg,
                            title: (0,i18n__WEBPACK_IMPORTED_MODULE_11__.t)("X\xe1c nhận đổi đại l\xfd"),
                            okText: (0,i18n__WEBPACK_IMPORTED_MODULE_11__.t)("Đồng \xfd"),
                            cancelText: (0,i18n__WEBPACK_IMPORTED_MODULE_11__.t)("Hủy"),
                            onOk: async ()=>{
                                try {
                                    await userService.confirmFarmer(refCode);
                                    onAssignDealerSuccess();
                                } catch (er) {
                                    handleConfirmError(er);
                                }
                            },
                            onCancel: onCancelPopup
                        });
                    } else {
                        await userService.confirmFarmer(refCode);
                        onAssignDealerSuccess();
                    }
                } catch (er) {
                    _teko_log__WEBPACK_IMPORTED_MODULE_6__/* .logger.error */ .k.error("Confirm farmer error code", er);
                    popup({
                        message: (0,_teko_utils__WEBPACK_IMPORTED_MODULE_13__/* .customizedMessage */ .$e)((0,i18n__WEBPACK_IMPORTED_MODULE_11__.t)("M\xe3 giới thiệu {refCode} kh\xf4ng hợp lệ"), [
                            {
                                name: "refCode",
                                value: refCode
                            }
                        ])
                    });
                    sessionStorage.removeItem("ref_code");
                }
            })();
        }
    }, [
        refCode,
        user
    ]);
    return {
        loading
    };
};
const ForceLogin = (param)=>{
    let { children  } = param;
    var ref;
    const { isMobile , identityRequired , supportedPhone: hotline , requireLogin , requiresUserOverEighteenYearsOld ,  } = (0,contexts__WEBPACK_IMPORTED_MODULE_7__/* .useTenantConfig */ .Wx)();
    const { user , loading , authService , loginWithPartner  } = (0,_teko_auth_react__WEBPACK_IMPORTED_MODULE_8__/* .useAuth */ .a)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const isBypassed = BYPASS_LOGIN_PATHS.test(router.route) || router.asPath.includes("/login") || router.asPath.includes("/logout");
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!loading && !(user === null || user === void 0 ? void 0 : user.userId) && !isBypassed) {
            if (!_terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isAvailable */ .Z.isAvailable()) authService.login();
            else {
                const partnerLogin = async ()=>{
                    const [accessToken, userInfo] = await Promise.all([
                        _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_4__/* ["default"].auth */ .Z.auth().getAccessTokenAsync(),
                        _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_4__/* ["default"].auth */ .Z.auth().getFullUserInfo(), 
                    ]);
                    loginWithPartner({
                        partnerType: "consumerapp",
                        userInfo: {
                            userId: userInfo.sub,
                            name: userInfo.name,
                            accessToken,
                            phone: userInfo.phoneNumber,
                            picture: userInfo.picture,
                            email: userInfo.email
                        }
                    }, false, false);
                };
                partnerLogin();
            }
        }
    }, [
        loading,
        user === null || user === void 0 ? void 0 : user.userId,
        isBypassed
    ]);
    // CP case:
    // todo: move this logic somewhere else. preferrably its own route
    const identityRefCode =  true ? window.sessionStorage.getItem("ref_code") : 0;
    const { loading: checkingDealer  } = useConfirmDealerAssignment(identityRefCode || "");
    if (!isBypassed && (loading || !user || checkingDealer)) {
        // iam is not initialized
        // return a loading screen
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Loading__WEBPACK_IMPORTED_MODULE_14__/* .PreLoad */ .b, {
            height: "100vh",
            isLoading: true
        });
    }
    if (isBypassed) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: children
        });
    }
    // after user login, there are some additional logic
    // like verifying if users have their profiles updated
    const isAccountActive = (user === null || user === void 0 ? void 0 : user.approvalStatus) === _teko_user__WEBPACK_IMPORTED_MODULE_15__/* .ApprovalStatus.APPROVED */ .K.APPROVED && !!(user === null || user === void 0 ? void 0 : user.isActive);
    if (!isAccountActive) {
        return isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UpdateProfileMobile, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UpdateProfileDesktop, {});
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            children,
            /* bypass check dealer when consumer web is opened in iframe */ !(0,_teko_utils__WEBPACK_IMPORTED_MODULE_13__/* .inIframe */ .yL)() && !(user === null || user === void 0 ? void 0 : (ref = user.dealer) === null || ref === void 0 ? void 0 : ref.id) && identityRequired === "dealer-required" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_16__/* .Modal */ .u, {
                visible: true,
                showCloseIcon: false,
                title: (0,i18n__WEBPACK_IMPORTED_MODULE_11__.t)("Th\xf4ng b\xe1o"),
                okText: "",
                onCancel: ()=>{
                    if (requireLogin) {
                        var // force logging out in case login is required in the whole site
                        ref, ref1;
                        window === null || window === void 0 ? void 0 : (ref = window.TekoID) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.logout();
                    } else {
                        // back to previous page when there's one page surrounded by ForceLogin
                        router.back();
                    }
                },
                cancelText: requireLogin ? (0,i18n__WEBPACK_IMPORTED_MODULE_11__.t)("Đăng xuất") : (0,i18n__WEBPACK_IMPORTED_MODULE_11__.t)("Đ\xf3ng"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_12__/* .Body */ .uT, {
                    children: (0,_teko_utils__WEBPACK_IMPORTED_MODULE_13__/* .customizedMessage */ .$e)((0,i18n__WEBPACK_IMPORTED_MODULE_11__.t)("_template.desktop._module.components.IdentityRequired.0"), [
                        {
                            name: "hotline",
                            value: hotline || ""
                        }
                    ])
                })
            }),
            requiresUserOverEighteenYearsOld && (!(user === null || user === void 0 ? void 0 : user.dob) || !(0,helpers__WEBPACK_IMPORTED_MODULE_17__/* .isOver18YearOld */ .xW)(user.dob)) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UpdateInfoForm, {})
        ]
    });
};


/***/ }),

/***/ 10413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ LazyComponent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61261);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84443);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91987);



function LazyComponent(param) {
    let { children , timeToRender =0  } = param;
    const ref = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null);
    const { isBot  } = (0,contexts__WEBPACK_IMPORTED_MODULE_2__/* .useGlobalData */ .U5)();
    const { 0: hydrated , 1: setHydrated  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(isBot ? true : false);
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(()=>{
        if (isBot || !ref.current) return;
        const ob = new IntersectionObserver((entries, observer)=>{
            for (const entry of entries){
                if (entry.isIntersecting) {
                    setHydrated(true);
                    observer.disconnect();
                    return;
                }
            }
        });
        ob.observe(ref.current);
        function hydrate(deadline) {
            if (deadline.timeRemaining() > timeToRender) {
                setHydrated(true);
                ob.disconnect();
            } else {
                requestIdleCallback(hydrate);
            }
        }
        if (timeToRender > 0) {
            requestIdleCallback(hydrate);
        }
        return ()=>ob.disconnect();
    }, [
        isBot,
        timeToRender
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: ref,
        className: "lazy-component",
        children: hydrated ? children : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "fake-body",
            style: {
                width: "100%",
                height: 200
            }
        })
    });
}


/***/ }),

/***/ 35904:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ PreLoad; },
/* harmony export */   "g": function() { return /* binding */ Loading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91987);
/* harmony import */ var _contexts_GlobalDataContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84443);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12433);




const Loading = (param)=>{
    let { isLoading , children  } = param;
    var ref;
    const { logo  } = (0,_contexts_GlobalDataContext__WEBPACK_IMPORTED_MODULE_2__/* .useGlobalData */ .U5)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Loading */ .g, {
        isLoading: isLoading,
        logo: (ref = (logo === null || logo === void 0 ? void 0 : logo.loading) || (logo === null || logo === void 0 ? void 0 : logo.lite)) === null || ref === void 0 ? void 0 : ref.path,
        children: children
    });
};
const PreLoad = (param)=>{
    let { isLoading , height  } = param;
    var ref;
    const { logo  } = (0,_contexts_GlobalDataContext__WEBPACK_IMPORTED_MODULE_2__/* .useGlobalData */ .U5)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Loading */ .g, {
        isLoading: isLoading,
        style: {
            height: typeof height === "number" ? "".concat(height, "px") : height
        },
        logo: (ref = (logo === null || logo === void 0 ? void 0 : logo.loading) || (logo === null || logo === void 0 ? void 0 : logo.lite)) === null || ref === void 0 ? void 0 : ref.path
    });
};


/***/ }),

/***/ 23425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* binding */ useTermsAndPolicies; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(84443);
// EXTERNAL MODULE: ./services/clients/api.ts
var api = __webpack_require__(44844);
;// CONCATENATED MODULE: ./services/cosmic.ts

const accessKey = {
    vnshop: "ulISdNDAN9MMpNCfXhTOSNQdh9tF0xXOL65PdIz6cfw7J319cG",
    karavan: "N0VNt8uGaO0QxlXLEKGcIsKiqGYeuejw0AK4YeYjla0A1qLlVN",
    umbala: "5KihnfendgNLL7k4zZVjBiwE27nYcKcuz6kwxpTXHo8AxYPrRf",
    vinmart: "6OC98OJNAOT9qzq1g6t6UnP72zqOt5tXMurVJ2qELvKovQX70M",
    cpvn: "vXraTMSIWKfTpYZX1YV9LO8XX0Q5pQXLRr9kgGlri635EUlisf",
    takashimaya: "JOUu6Kf1RuuSHfsegx2fkzd13NJSCcrOvxXB6gI6QpYIna4LCv",
    vnpay: "ZvfT9WRG2KZ2dEF8tCRaKgbJZRdqhG0XckUHzkBhHy8XaGHK7K",
    ipp: "YO71gfq1uvrjBaScttrzp4CV6rs5oOfzq4dvrdFACH13wYEHEr",
    soibien: "FjourKXWwl12MoIDd4nj0ZxMwS18G2OUva7wSW6b3iG95Z92x6",
    meatdeli: "TvYF1WNXCIH7bU6dMebRkSyW2dVI3WtZUz2iEogVFjxRtRSuPH",
    apaos: "xn1DNyDK4UtDVvPCYBQNcjD5bWOw0XqE6zF69pOt0tWJPFnEpW",
    "policy-sms": "rNPixiLvJ5s198BVppBXvtyNQVStxByvWFJ2PaRB8qknX79Saw",
    cyhome: "KJ0plXySpMdrFnGJWZjk7jbuu9TK3bZWlsrYwxXO6pUqQMNG1r",
    maxtrust: "iWJlZ86Rrnxo1OW10exkeFiXiQIVbMO9J6HKHVe6TCaZz1U6Yp"
};
/*
 * map tenant name to bucket slug name
 * if they are not the same
 * */ const cosmicPath = {
    cp: "cpvn",
    sms: "policy-sms"
};
const getApiKey = (tenant)=>{
    return accessKey[cosmicPath[tenant] || tenant];
};
const cosmicService = {
    getSlugs: async (tenant)=>{
        var ref;
        const readKey = getApiKey(tenant);
        if (!readKey) return [];
        const resp = await api/* cosmicApi.get */.pr.get("/".concat(cosmicPath[tenant] || tenant, "/objects"), {
            params: {
                pretty: true,
                hide_metafields: true,
                props: "slug,title",
                read_key: readKey
            }
        });
        return resp === null || resp === void 0 ? void 0 : (ref = resp.data) === null || ref === void 0 ? void 0 : ref.objects;
    },
    getPost: async (slug, tenant)=>{
        var ref;
        const readKey = getApiKey(tenant);
        if (!readKey) return null;
        const resp = await api/* cosmicApi.get */.pr.get("/".concat(cosmicPath[tenant] || tenant, "/object/").concat(slug), {
            params: {
                hide_metafields: true,
                type: "posts",
                props: "slug,title,content",
                read_key: readKey
            }
        });
        return resp === null || resp === void 0 ? void 0 : (ref = resp.data) === null || ref === void 0 ? void 0 : ref.object;
    }
};
/* harmony default export */ var cosmic = (cosmicService);

// EXTERNAL MODULE: ./helpers/index.ts
var helpers = __webpack_require__(88813);
;// CONCATENATED MODULE: ./hooks/useTermsAndPolicies.ts




const useTermsAndPolicies = ()=>{
    const { 0: termsAndPolicies , 1: setTermsAndPolicies  } = (0,react.useState)([]);
    const { partner , tenant  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const cosmicBucketName = partner && (0,helpers/* isVnpay */.EU)(partner) ? "vnpay" : tenant;
    const getPost = async (slug)=>{
        return await cosmic.getPost(slug, cosmicBucketName);
    };
    (0,react.useEffect)(()=>{
        if (!cosmicBucketName) {
            return;
        }
        cosmic.getSlugs(cosmicBucketName).then((slugs)=>{
            setTermsAndPolicies(slugs);
        });
    }, [
        cosmicBucketName
    ]);
    return {
        getPost,
        termsAndPolicies
    };
};


/***/ }),

/***/ 54970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Layout": function() { return /* binding */ Layout; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(34655);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-48286aefe3/1/packages/ecommerce/dist/Layout/Footer/Footer.es.js + 1 modules
var Footer_es = __webpack_require__(32777);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-48286aefe3/1/packages/ecommerce/dist/Common/CustomLink/CustomLink.es.js
var CustomLink_es = __webpack_require__(96494);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/libs/styled.es.js
var styled_es = __webpack_require__(86029);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/LazyImage/LazyImage.es.js
var LazyImage_es = __webpack_require__(30752);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/molecules/ScrollTopArrow/ScrollTopArrow.es.js
var ScrollTopArrow_es = __webpack_require__(56265);
// EXTERNAL MODULE: ./tenants/_template/desktop/_module/components/NavigationBar.tsx + 1 modules
var NavigationBar = __webpack_require__(90588);
// EXTERNAL MODULE: ../../packages/tracking/dist/helper.es.js
var helper_es = __webpack_require__(28247);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-53f627c913/1/packages/ds-icon/dist/components/MessengerColored.es.js
var MessengerColored_es = __webpack_require__(50297);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-dae21f56e7/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(21483);
;// CONCATENATED MODULE: ./tenants/_template/desktop/_module/components/MessengerIcon.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  z-index: 1030;\n  position: fixed;\n  right: 2.5rem;\n  bottom: 5.6rem;\n  cursor: pointer;\n  @media print {\n    display: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





const Wrapper = emotion_styled_browser_esm["default"].div(_templateObject());
const MessengerIcon = (param)=>{
    let { url  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, _objectSpreadProps(_objectSpread({
        className: "fb-chat-full",
        onClick: ()=>window.open(url, "_blank")
    }, (0,helper_es/* getTrackingData */.O5)({
        isTrackContent: true,
        regionName: "quickAction",
        contentName: "fbMessengerIcon",
        payload: JSON.stringify({
            url
        })
    })), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MessengerColored_es/* MessengerColored */.q, {
            size: 60
        })
    }));
};

// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(84443);
// EXTERNAL MODULE: ./hooks/useTermsAndPolicies.ts + 1 modules
var useTermsAndPolicies = __webpack_require__(23425);
// EXTERNAL MODULE: ./components/ForceLogin.tsx
var ForceLogin = __webpack_require__(92926);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/components/Zalo/Zalo.es.js + 2 modules
var Zalo_es = __webpack_require__(66409);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/components/Topbar/Topbar.es.js
var Topbar_es = __webpack_require__(738);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/components/Topbar/TopbarButton.es.js
var TopbarButton_es = __webpack_require__(7934);
;// CONCATENATED MODULE: ./tenants/_template/desktop/_module/_constants.ts
const MEMBERSHIP_POLICY_SLUG_PREFIX = "membership-policy";
const BYPASS_LOGIN_PATHS = /^.*(\/content\/\[id\])|(\/p\/\[slug\])$/g;

// EXTERNAL MODULE: ./components/LazyComponent.tsx
var LazyComponent = __webpack_require__(10413);
// EXTERNAL MODULE: ./hooks/useQuery.tsx
var useQuery = __webpack_require__(46818);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/dynamic.js
var dynamic = __webpack_require__(85470);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./tenants/_template/desktop/_module/Layout.tsx
function Layout_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Layout_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Layout_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Layout_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Layout_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Layout_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Layout_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Layout_templateObject() {
    const data = Layout_taggedTemplateLiteral([
        "\n  height: 56px;\n  @media print {\n    display: none;\n  }\n"
    ]);
    Layout_templateObject = function _templateObject() {
        return data;
    };
    return data;
}















const PbLayout = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(3712), __webpack_require__.e(9456), __webpack_require__.e(4615), __webpack_require__.e(5035), __webpack_require__.e(7670), __webpack_require__.e(6222), __webpack_require__.e(4691), __webpack_require__.e(1618)]).then(__webpack_require__.bind(__webpack_require__, 33373)).then((mod)=>mod.PbLayout), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(33373)
            ]
    }
});
const TopBannerHeight = styled_es/* styled.div */.z.div(Layout_templateObject());
const DefaultLayout = (param)=>{
    let { children , banners , leftMenu , rightMenu , footerData , footer , navigationBar , forceLogin =false , layoutConfig , pageProps  } = param;
    const LoginWrapper = forceLogin ? ForceLogin/* ForceLogin */.D : react.Fragment;
    const { contactLink , isDisplayMessenger , zaloContactLink , partner , footerDataConfig , noOverride , epicPb1887 ,  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const topBanner = banners === null || banners === void 0 ? void 0 : banners[0];
    if (epicPb1887) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PbLayout, {
            config: layoutConfig || {},
            pageProps: pageProps,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LoginWrapper, {
                children: [
                    children,
                    contactLink && isDisplayMessenger && /*#__PURE__*/ (0,jsx_runtime.jsx)(MessengerIcon, {
                        url: contactLink
                    }),
                    zaloContactLink && /*#__PURE__*/ (0,jsx_runtime.jsx)(Zalo_es/* Zalo */.R, {
                        url: zaloContactLink
                    })
                ]
            })
        });
    }
    if (!footer && footerData || noOverride) {
        var ref;
        const footerLayout = noOverride ? Layout_objectSpreadProps(Layout_objectSpread({}, footerData), {
            supportAndPolicy: [
                ...(ref = footerDataConfig === null || footerDataConfig === void 0 ? void 0 : footerDataConfig["supportAndPolicy"]) !== null && ref !== void 0 ? ref : [], 
            ]
        }) : footerData;
        footer = /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_es/* Footer */.$, {
            footer: footerLayout !== null && footerLayout !== void 0 ? footerLayout : {}
        });
    }
    const renderContent = ()=>{
        // Render custom pages
        // if (allowRenderCustomPage) {
        //   return <>{children}</>;
        // }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                !partner && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        topBanner && /*#__PURE__*/ (0,jsx_runtime.jsx)(TopBannerHeight, Layout_objectSpreadProps(Layout_objectSpread({}, (0,helper_es/* getTrackingData */.O5)({
                            regionName: "topBanner",
                            isTrackContent: true
                        })), {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink_es/* CustomLink */.x, {
                                targetPath: topBanner.targetPath,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage_es/* LazyImage */.w, {
                                    imageWidth: 1920,
                                    height: 56,
                                    cover: true,
                                    src: topBanner.image
                                })
                            })
                        })),
                        (leftMenu || rightMenu) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Topbar_es/* Topbar */.Z, {
                            leftMenu: leftMenu,
                            rightMenu: rightMenu
                        })
                    ]
                }),
                navigationBar,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: children
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyComponent/* LazyComponent */.c, {
                    children: footer
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginWrapper, {
                children: renderContent()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollTopArrow_es/* ScrollTopArrow */.C, {}),
            contactLink && isDisplayMessenger && /*#__PURE__*/ (0,jsx_runtime.jsx)(MessengerIcon, {
                url: contactLink
            }),
            zaloContactLink && /*#__PURE__*/ (0,jsx_runtime.jsx)(Zalo_es/* Zalo */.R, {
                url: zaloContactLink
            })
        ]
    });
};
const Layout = (_param)=>{
    var { children , banners , leftMenu , rightMenu , footerData , footer , navigationBar , menuItems , liteLogo , forceLogin =false , layoutAreas  } = _param, props = _objectWithoutProperties(_param, [
        "children",
        "banners",
        "leftMenu",
        "rightMenu",
        "footerData",
        "footer",
        "navigationBar",
        "menuItems",
        "liteLogo",
        "forceLogin",
        "layoutAreas"
    ]);
    const { identityRequired , hasNews  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { termsAndPolicies  } = (0,useTermsAndPolicies/* useTermsAndPolicies */.N)();
    const { 0: requireLogin , 1: setRequireLogin  } = (0,react.useState)(forceLogin);
    const finalRightActions = hasNews ? [
        /*#__PURE__*/ (0,jsx_runtime.jsx)(TopbarButton_es/* TopbarButton */.S, {
            href: "/tin-tuc",
            children: (0,i18n.t)("Tin tức")
        }, 0),
        ...rightMenu !== null && rightMenu !== void 0 ? rightMenu : [], 
    ] : rightMenu !== null && rightMenu !== void 0 ? rightMenu : [];
    const query = (0,useQuery/* useQuery */.aM)({
        ref_code: useQuery/* StringParam */.Zp
    });
    (0,react.useEffect)(()=>{
        if (identityRequired && (query === null || query === void 0 ? void 0 : query.ref_code)) {
            sessionStorage.setItem("ref_code", query.ref_code.toString());
            setRequireLogin(true);
        } else if (!!sessionStorage.getItem("ref_code")) {
            // for case redirected back after login
            setRequireLogin(true);
        }
    }, []);
    if (!footer && footerData) {
        var ref, ref1;
        if (termsAndPolicies.length > 0 && !!((ref = footerData.supportAndPolicy) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.links)) {
            footerData.supportAndPolicy[0].links = termsAndPolicies.filter((param)=>{
                let { slug  } = param;
                return !slug.includes(MEMBERSHIP_POLICY_SLUG_PREFIX);
            }).map((param)=>{
                let { title , slug  } = param;
                return {
                    children: (0,i18n.t)(title),
                    href: "/".concat(slug),
                    target: "_blank"
                };
            });
        }
        footer = /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_es/* Footer */.$, {
            footer: footerData
        });
    }
    if (!navigationBar) {
        navigationBar = /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationBar/* NavigationBar */.vx, {
            menuItems: menuItems,
            showShippingFeeMiniCart: false,
            liteLogo: liteLogo
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultLayout, Layout_objectSpreadProps(Layout_objectSpread({
        leftMenu: leftMenu,
        rightMenu: finalRightActions,
        navigationBar: navigationBar,
        footer: footer,
        footerData: footerData,
        banners: banners,
        forceLogin: requireLogin,
        layoutAreas: layoutAreas
    }, props), {
        children: children
    }));
};


/***/ }),

/***/ 20483:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ ApprovalStatus; }
/* harmony export */ });
/* unused harmony export UserType */
var ApprovalStatus = /* @__PURE__ */ ((ApprovalStatus2) => {
  ApprovalStatus2["APPROVED"] = "approved";
  ApprovalStatus2["REJECTED"] = "rejected";
  ApprovalStatus2["NEW"] = "new";
  ApprovalStatus2["REQUEST_APPROVAL"] = "request_approval";
  return ApprovalStatus2;
})(ApprovalStatus || {});
var UserType = /* @__PURE__ */ ((UserType2) => {
  UserType2["CONSUMER"] = "consumer";
  UserType2["DEALER"] = "dealer";
  return UserType2;
})(UserType || {});




/***/ })

}]);